export { useDomainConfig } from "./useDomainConfig";
